import { useState } from 'react';
import { Marker, Popup } from 'react-map-gl/mapbox';
import type { SafePoint } from '../../../../types/gcs/mission';
import { getMapElementZIndex, MapElement } from '../../../../types/ui/mapElement';
import { Text } from '../../../../components/general/Text';
import { formatCoordinates } from '../../../../utils/formatters';

interface SafePointMarkerProps {
  safePoint: SafePoint;
}

export const SafePointMarker = ({ safePoint }: SafePointMarkerProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <Marker
        longitude={safePoint.location.lng}
        latitude={safePoint.location.lat}
        anchor='center'
        style={{ zIndex: getMapElementZIndex(MapElement.SAFE_POINT) }}
      >
        <svg
          width='32'
          height='32'
          viewBox='0 0 40 40'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{ cursor: 'pointer' }}
          onClick={(event) => {
            event.stopPropagation();
            setIsPopupOpen((prev) => !prev);
          }}
        >
          <circle
            cx='20'
            cy='20'
            r='19'
            fill='var(--map-element-inflight-failure-mode)'
            stroke='white'
            strokeWidth='2'
          />
          <path
            d='M19.8204 30.8213C19.8139 30.8213 19.8074 30.8203 19.8008 30.8203H19.8389C19.8327 30.8203 19.8266 30.8213 19.8204 30.8213Z'
            fill='white'
          />
          <path
            d='M14.9337 20.8799C15.3459 22.7909 16.8499 24.2936 18.7608 24.7061L17.8477 30.6406C13.354 29.8267 9.81339 26.2859 9.00006 21.792L14.9337 20.8799Z'
            fill='white'
          />
          <path
            d='M30.6397 21.792C29.8262 26.2861 26.2861 29.8269 21.7921 30.6406L20.879 24.7061C22.7901 24.2938 24.2938 22.791 24.7061 20.8799L30.6397 21.792Z'
            fill='white'
          />
          <path
            d='M18.7608 14.9346C16.8498 15.347 15.3459 16.8507 14.9337 18.7617L9.00006 17.8477C9.81405 13.3546 13.3545 9.81377 17.8477 9L18.7608 14.9346Z'
            fill='white'
          />
          <path
            d='M21.7921 9C26.2856 9.81351 29.8256 13.3544 30.6397 17.8477L24.7061 18.7617C24.2937 16.8505 22.7902 15.3468 20.879 14.9346L21.7921 9Z'
            fill='white'
          />
        </svg>
      </Marker>
      {isPopupOpen && (
        <Popup
          longitude={safePoint.location.lng}
          latitude={safePoint.location.lat}
          anchor='bottom'
          offset={32}
          className='marker-popup'
          closeButton={true}
          closeOnClick={true}
          onClose={() => setIsPopupOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Text variant='body2'>{formatCoordinates(safePoint.location.lat, safePoint.location.lng)}</Text>
          </div>
        </Popup>
      )}
    </>
  );
};
